// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__19mhG","title":"Info_title__3pRCo","selects":"Info_selects__36RAP","requiredAsterisk":"Info_requiredAsterisk__1iL5t"};